export default __webpack_public_path__ + "static/media/events_vector.df3be1a6.svg";